import React from 'react';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';

/**
 * @component The component renders the Spatial Engineering page
 * @return {Component} SpatialEngineering component
 */
export default function DevelopmentsPage() {
  return (
    <Card style={{
      padding: '50px',
      width: '1200px',
      margin: '30px',
    }}>
      <Grid item xs={12} md={8}>
        <Typography variant="h6" gutterBottom>
          <h2>Intra-geospatial engineering</h2>
        </Typography>
        <Divider />
        <p style={{fontSize: '16px', lineHeight: '24px'}}>
          Immersing into Virtual Reality (VR) and Augmented Reality (AR)
          environments are ways scientists research and discover new ideas,
          concepts, and facts about the world around us. Yet even the most
          sophisticated computer systems present obstacles and limitations
          that give VR and AR applications limited authority over the
          examples, demonstrations and figures scientists seek to define in a
          permanent manner.
        </p>
        <p>
          In response to the limitations and preventions of
          virtual reality research, Advanced Intelligence Service Corp.
          developed Predictive Reality (PR), a virtual research concept
          designed to observe and discover facts about the Universe based
          around the progression of physics, rather than digital data.
          Intra-geospatial engineering is the process of immersing in a PR
          environment for the purpose of verifying scientific observations,
          fact determination, or the processes of identifying the power of
          authority of scientific, legal, or social protocol over a historical
          event product, sequence, or effect of scientific relevancy.
        </p>
        <p>
          The observation of physics data over digital representations ensures
          an ultimate level of precision in validating the proficiency of
          results of a particular event of scientific discovery, as opposed to
          relying on inaccurate or biased post-effect details.
        </p>


      </Grid>
    </Card>
  );
}
